import AbstractModelType from '../AbstractModelType';

class UserContentShareSubscription extends AbstractModelType {
  #sharer;
  #isPaused;
  #code;

  constructor(properties = {}) {
    super(...arguments);

    this.#sharer = properties.sharer;
    this.#isPaused = properties.isPaused;
    this.#code = properties.code;
  }

  get sharer() {
    return this.#sharer;
  }

  get isPaused() {
    return this.#isPaused;
  }

  get code() {
    return this.#code;
  }
}

export default UserContentShareSubscription;
